// extracted by mini-css-extract-plugin
var _1 = "wDikzRQ2K12sQjMxMGr7";
export { _1 as "container" }
